import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const headers = {
  'Api-Key': process.env.REACT_APP_API_KEY,
};



const httpGet = async (url) => {
  return axios.get(url, { headers });
};

const httpGetPublic = async (url) => {
  return axios.get(url);
};
const httpPost = async (url, data) => {
  return axios.post(url, data, { headers });
};

const httpPatch = async (url, data) => {
  return axios.patch(url, data, { headers });
};

const httpPut = async (url, data) => {
  return axios.put(url, data, { headers });
};

const httpDelete = async (url) => {
  return axios.delete(url, { headers });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: httpGet,
  getPublic: httpGetPublic,
  post: httpPost,
  patch: httpPatch,
  put: httpPut,
  delete: httpDelete,
};
